import Header from '../components/header';
import Footer from '../components/footer';
import React from 'react';
import '../index.css';
import { Container, Row, Col, Image, Button } from 'react-bootstrap';
import profile from '../assets/images/me.png';
import { FaDownload, FaEnvelope} from 'react-icons/fa';
import { useDownloadResume } from '../hooks/useDownloadResume'

function Home() {
    const { downloadResume } = useDownloadResume();

    return (
        <>
            <Header />

            <Container className="home-container fade-in-up gap-3">
                {/* HERO SECTION */}
                <Row className="d-flex flex-column flex-lg-row align-items-center justify-content-between text-center text-lg-start">
                    {/* Text Content - Hidden on sm, visible on lg+ */}
                    <Col
                        xs={12}
                        lg={7}
                        className="d-none d-lg-block mt-md-3"
                    >
                        <div className="hello">
                            <h1>Hi,</h1>
                            <h1>I'm <span className="name">Doaa Ali</span></h1>
                            <h1>
                                A <span className="animated-role">Data Analyst</span>
                            </h1>
                        </div>
                        <p>
                            Transforming Numbers Into Smart Decisions
                        </p>

                        <div className="quick-btns d-flex flex-column flex-md-row align-items-center align-items-lg-start justify-content-center justify-content-lg-start p-2 gap-3">
                            <Button
                                className="px-3 py-2 outline-btn"
                                onClick={() => (window.location.href = "/contact")}
                            >
                                <FaEnvelope className="me-2" />
                                Contact Me
                            </Button>
                            <Button
                                className="px-3 py-2 filled-btn"
                                onClick={downloadResume}
                            >
                                <FaDownload className="me-2" />
                                Download My Resume
                            </Button>
                        </div>
                    </Col>

                    {/* Original Image - Hidden on sm, visible on lg+ */}
                    <Col
                        sm={12}
                        lg={5}
                        className="d-none d-lg-flex align-items-center justify-content-center justify-content-lg-end f-border"
                    >
                        <div className="s-border square-wrapper">
                            <Image
                                src={profile}
                                alt="Profile"
                                className="profile-img"
                            />
                        </div>
                    </Col>

                    {/* Mobile Layout - Visible on sm, hidden on lg+ */}
                    <Col
                        xs={12}
                        className="d-block d-lg-none text-center"
                    >
                        {/* Name and Description for mobile */}
                        <div className="hello">
                            <h1>Hi,</h1>
                            <h1>I'm <span className="name">Doaa Ali</span></h1>
                            <h1>
                                A <span className="animated-role">Data Analyst</span>
                            </h1>
                        </div>
                        <p>
                            Transforming Numbers Into Smart Decisions
                        </p>

                        {/* Image for mobile - Centered */}
                        <div className="d-flex align-items-center justify-content-center f-border my-4 mx-auto" style={{ width: 'fit-content' }}>
                            <div className="s-border square-wrapper">
                                <Image
                                    src={profile}
                                    alt="Profile"
                                    className="profile-img"
                                />
                            </div>
                        </div>

                        {/* Buttons for mobile */}
                        <div className="quick-btns d-flex flex-column flex-md-row align-items-center justify-content-center p-2 gap-3">
                            <Button
                                className="px-3 py-2 outline-btn"
                                onClick={() => (window.location.href = "/contact")}
                            >
                                Contact Me
                            </Button>
                            <Button
                                className="px-3 py-2 filled-btn"
                                onClick={downloadResume}
                            >
                                Download My Resume
                            </Button>
                        </div>
                    </Col>
                </Row>

                {/* ABOUT SECTION */}
                <Row className="d-flex align-items-center justify-content-center mt-5 text-center text-lg-start">
                    <Col lg={12}>
                        <h2 className="heading mb-3">ABOUT</h2>
                        <p>
                            Hi, I’m <strong>Doaa Ali</strong> — a recent Computer Science graduate who’s passionate about turning data into stories that make sense.
                            I love working with numbers, patterns, and systems to uncover insights that actually help people make smarter decisions.
                        </p>

                        <p>
                            My interests span both <span className="role">Data Analysis</span> and <span className="role">Data Engineering</span>.
                            I’ve worked with <span className="tool">Excel</span>, <span className="tool">Power BI</span>, and <span className="tool">Python</span> for analysis,
                            and I’ve also built <span className="tool">ETL</span> workflows using tools like <span className="tool">SSIS</span> and <span className="tool">SQL</span>.
                            I enjoy creating clean data pipelines, designing <span className="tool">databases</span>, and working with <span className="tool">data warehouses</span>
                            that make analysis easier and more accurate.
                        </p>

                        <p>
                            With a background in <span className="role">Software Engineering</span> and <span className="role">System Analysis</span>,
                            I’m comfortable designing system workflows, writing code in
                            <span className="tool"> Python</span>, <span className="tool">Java</span>, and <span className="tool">C++</span>,
                            and creating structured solutions that connect both technical and analytical perspectives.
                            Whether it’s building a small dashboard, modeling system requirements, or automating data processes,
                            I enjoy solving problems and continuously learning how to make technology more useful and efficient.
                        </p>

                        <p>
                            Outside of code and data, I value clear communication, teamwork, and creative thinking —
                            because great insights mean nothing unless they’re understood and used effectively.
                        </p>
                    </Col>
                </Row>



            </Container>

            <Footer />
        </>
    );
}

export { Home };
